// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../static/images/syster-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.syster {
  width: 1200px;
  margin: 0px auto;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.05);
  margin-bottom: 50px;
}
.syster .ant-tabs-nav-list {
  background: #f5f5f5;
  border-right: 1px solid #ddd;
  width: 220px;
}
.syster .ant-tabs-nav-list .ant-tabs-tab {
  margin-top: 0px !important;
  margin: 0px !important;
  padding: 0px !important;
}
.syster .ant-tabs-nav-list .ant-tabs-tab .ant-tabs-tab-btn {
  text-align: center;
  width: 100%;
  height: 50px;
  line-height: 50px;
}
.syster .ant-tabs-nav-list .ant-tabs-tab-active .ant-tabs-tab-btn {
  background: #fff;
  position: relative;
}
.syster .ant-tabs-nav-list .ant-tabs-tab-active .ant-tabs-tab-btn::after {
  content: '';
  width: 2px;
  height: 50px;
  position: absolute;
  right: -2px;
  display: inline-block;
  background: #fff;
}
.syster .ant-tabs-nav-list .ant-tabs-ink-bar {
  display: none;
}
.syster .ant-tabs-tabpane {
  padding-left: 0px !important;
}
.syster-ul {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
}
.syster-ul li {
  line-height: 40px;
  width: calc(33.3% - 10px);
  border: 1px solid #d0ddf2;
  background: #fbfcff;
  border-radius: 5px;
  margin-bottom: 15px;
  box-sizing: border-box;
  cursor: pointer;
}
.syster-ul li img {
  margin-right: 10px;
  vertical-align: -8px;
  margin-left: 15px;
  width: 26px;
}
.syster-ul li:hover {
  border: 1px solid #d0ddf2;
  background: #ebeef6;
}
.syster-ul .list {
  margin-left: 15px;
  margin-right: 15px;
}
.systerBanner {
  height: 430px;
  min-width: 1200px;
  width: 100%;
  background: #e9edf5 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat top center;
}
.systerBanner .textBox {
  width: 1200px;
  margin: 0px auto;
  padding-top: 120px;
}
.systerBanner .textBox h2 {
  margin: 0px;
  font-size: 36px;
  color: #444;
  padding-bottom: 15px;
}
.systerBanner .textBox p {
  margin: 0px;
  padding-bottom: 10px;
  width: 720px;
  color: #444;
  line-height: 30px;
}
.img-dialog {
  position: absolute;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
}
.imgheight {
  height: 70vh;
}
.businessArchitecture {
  display: flex;
  width: 1200px;
  margin: 0px auto;
}
.businessArchitecture > div {
  flex: 1;
  background: #fff;
  margin-right: 15px;
  text-align: center;
}
.businessArchitecture > div span {
  margin: 0px 0px 15px 0px;
  border-radius: 0px;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  padding: 0px;
  background: #0052d9;
  color: #fff;
  display: block;
}
.businessArchitecture > div:last-child {
  margin-right: 0px;
}
.businessArchitecture ul::after {
  content: '······';
  background: #eaebf2;
  border-radius: 5px;
  margin: 0px 10px 15px 10px;
  font-size: 14px;
  line-height: 22px;
  padding: 12px 0px;
  display: block;
}
.businessArchitecture ul li {
  background: #eaebf2;
  border-radius: 5px;
  margin: 0px 10px 15px 10px;
  font-size: 14px;
  line-height: 16px;
  padding: 15px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Syster/index.less"],"names":[],"mappings":"AAAA;EAAQ,aAAA;EAAc,gBAAA;EAAkB,sBAAA;EAAuB,mBAAA;EAa5D,+CAAA;EAA8C,mBAAA;AANjD;AAPA;EACsB,mBAAA;EAAoB,4BAAA;EAA6B,YAAA;AAWvE;AAZA;EAEqB,0BAAA;EAA2B,sBAAA;EAAuB,uBAAA;AAevE;AAjBA;EAG2B,kBAAA;EAAmB,WAAA;EAAY,YAAA;EAAa,iBAAA;AAoBvE;AAvBA;EAM2B,gBAAA;EAAiB,kBAAA;AAqB5C;AA3BA;EAOkC,WAAA;EAAY,UAAA;EAAW,YAAA;EAAa,kBAAA;EAAoB,WAAA;EAAY,qBAAA;EAC1F,gBAAA;AA4BZ;AApCA;EAWwB,aAAA;AA4BxB;AAvCA;EAcqB,4BAAA;AA4BrB;AA3BG;EAAM,aAAA;EAAe,eAAA;EAAiB,aAAA;AAgCzC;AAhCG;EAEM,iBAAA;EAAkB,yBAAA;EAA0B,yBAAA;EAA0B,mBAAA;EACtE,kBAAA;EAAmB,mBAAA;EAAoB,sBAAA;EAAwB,eAAA;AAuCxE;AA1CG;EAIU,kBAAA;EAAmB,oBAAA;EAAqB,iBAAA;EAAmB,WAAA;AA4CxE;AAhDG;EAMY,yBAAA;EAA0B,mBAAA;AA8CzC;AApDG;EAOS,iBAAA;EAAkB,kBAAA;AAiD9B;AA7CA;EACG,aAAA;EAAc,iBAAA;EAAkB,WAAA;EAAY,gFAAA;AAkD/C;AAnDA;EAEY,aAAA;EAAc,gBAAA;EAAiB,kBAAA;AAsD3C;AAxDA;EAGS,WAAA;EAAa,eAAA;EAAgB,WAAA;EAAY,oBAAA;AA2DlD;AA9DA;EAIQ,WAAA;EAAY,oBAAA;EAAqB,YAAA;EAAa,WAAA;EAAY,iBAAA;AAiElE;AA9DA;EAAY,kBAAA;EAAmB,WAAA;EAAY,aAAA;EAAe,8BAAA;AAoE1D;AAnEA;EAAW,YAAA;AAsEX;AArEA;EAAsB,aAAA;EAAc,aAAA;EAAc,gBAAA;AA0ElD;AA1EA;EACQ,OAAA;EAAQ,gBAAA;EAAiB,kBAAA;EAAmB,kBAAA;AA+EpD;AAhFA;EAEY,wBAAA;EAAyB,kBAAA;EAAmB,iBAAA;EAAkB,YAAA;EAAa,iBAAA;EAAkB,eAAA;EAAgB,YAAA;EAAa,mBAAA;EAAoB,WAAA;EAAY,cAAA;AA0FtK;AA5FA;EAGiB,iBAAA;AA4FjB;AA/FA;EAIY,iBAAA;EAAiB,mBAAA;EAAoB,kBAAA;EAAmB,0BAAA;EAA2B,eAAA;EAAgB,iBAAA;EAAkB,iBAAA;EAAkB,cAAA;AAqGnJ;AAzGA;EAKQ,mBAAA;EAAoB,kBAAA;EAAmB,0BAAA;EAA2B,eAAA;EAAgB,iBAAA;EAAkB,iBAAA;AA4G5G","sourcesContent":[".syster{width:1200px; margin: 0px auto; border:1px solid #ddd; border-radius:10px;\n   .ant-tabs-nav-list{background:#f5f5f5; border-right:1px solid #ddd; width:220px;\n      .ant-tabs-tab{ margin-top:0px !important; margin:0px !important; padding:0px !important;\n         .ant-tabs-tab-btn{text-align:center; width:100%; height:50px; line-height:50px;}\n      } \n      .ant-tabs-tab-active{\n         .ant-tabs-tab-btn{background:#fff; position: relative;}\n         .ant-tabs-tab-btn::after{content:''; width:2px; height:50px; position: absolute; right:-2px; display: inline-block;\n            background: #fff;\n         }\n      }\n      .ant-tabs-ink-bar{display: none;}\n   }\n   box-shadow: 0px 0px 5px 5px rgba(0,0,0,0.05); margin-bottom:50px;\n   .ant-tabs-tabpane{padding-left:0px !important;}\n   &-ul{ display: flex; flex-wrap: wrap; padding:20px;\n      li{\n         line-height:40px; width:calc(33.3% - 10px); border:1px solid #d0ddf2; background:#fbfcff; \n         border-radius:5px; margin-bottom:15px; box-sizing: border-box; cursor: pointer;\n         img{margin-right:10px; vertical-align:-8px; margin-left: 15px; width:26px;}\n      }\n      li:hover{border:1px solid #d0ddf2; background:#ebeef6; }\n      .list{margin-left:15px; margin-right:15px;}\n   }\n   \n}\n.systerBanner{\n   height:430px; min-width:1200px; width:100%; background:#e9edf5 url(../../static/images/syster-banner.jpg) no-repeat top center;\n   .textBox{width:1200px; margin:0px auto; padding-top:120px;\n      h2{margin: 0px; font-size:36px; color:#444; padding-bottom:15px;}\n      p{margin:0px; padding-bottom:10px; width:720px; color:#444; line-height:30px;}\n   }\n}\n.img-dialog{position:absolute; width:100%; height: 100vh; background:rgba(0,0,0,0.5);}\n.imgheight{height:70vh}\n.businessArchitecture{display:flex; width:1200px; margin: 0px auto;\n   >div{flex:1; background:#fff; margin-right:15px; text-align: center;}\n\t >div span{margin:0px 0px 15px 0px; border-radius:0px; font-weight:bold; height:40px; line-height:40px; font-size:16px; padding:0px; background:#0052d9; color:#fff; display: block;}\n\t>div:last-child{margin-right:0px;}\n\t ul::after{content:'······';background:#eaebf2; border-radius:5px; margin:0px 10px 15px 10px; font-size:14px; line-height:22px; padding:12px 0px; display:block;}\n\t ul li{background:#eaebf2; border-radius:5px; margin:0px 10px 15px 10px; font-size:14px; line-height:16px; padding:15px 0px;}\n}\n\t"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
